(()=>{
  const reduce=matchMedia('(prefers-reduced-motion: reduce)');
  const desktop=matchMedia('(min-width: 48rem)');
  const interactive='a,button,input,select,textarea,label,summary,[role="button"]';

  const init=root=>{
    if(!root||root.dataset.mzOrbitV41Bound==='true')return;
    root.dataset.mzOrbitV41Bound='true';

    const stage=root.querySelector('[data-gallery-stage]');
    const viewport=root.querySelector('.product-gallery__viewport');
    const rail=root.querySelector('.product-gallery__rail');
    if(!stage)return;

    let raf=0,startX=null,lastX=null,lastT=0,velocity=0;

    const slides=()=>[...root.querySelectorAll('[data-gallery-slide]')];
    const thumbs=()=>[...root.querySelectorAll('[data-gallery-thumbnail]')];
    const activeIndex=()=>Math.max(0,(Number(root.dataset.galleryCurrent)||1)-1);

    const circularDelta=(i,a,n)=>{
      let d=i-a;
      if(n>1){
        if(d>n/2)d-=n;
        if(d<-n/2)d+=n;
      }
      return d;
    };

    const go=index=>{
      const all=slides();
      const n=all.length;
      if(n<2)return;
      const target=((index%n)+n)%n;
      const mediaId=all[target]?.dataset?.mediaId;
      const thumb=thumbs().find(t=>String(t.dataset?.mediaId)===String(mediaId));
      if(thumb){
        thumb.click();
        return;
      }
      /* Defensive fallback if a future product has more media than rendered thumbnails. */
      all.forEach((s,i)=>s.dataset.gallerySelected=i===target?'true':'false');
      root.dataset.galleryCurrent=String(target+1);
      const current=root.querySelector('[data-gallery-counter-current]');
      if(current)current.textContent=String(target+1);
      paint();
    };

    const navigate=dir=>go(activeIndex()+dir);

    const unlockArrows=n=>{
      root.querySelectorAll('[data-gallery-previous],[data-gallery-next]').forEach(btn=>{
        btn.disabled=n<2;
        btn.setAttribute('aria-disabled',n<2?'true':'false');
      });
    };

    const cleanup=()=>{
      root.removeAttribute('data-gallery-orbit');
      root.removeAttribute('data-mz-orbit-ready');

      for(const el of [viewport,stage,rail].filter(Boolean)){
        for(const key of ['height','min-height','max-height'])el.style.removeProperty(key);
      }

      slides().forEach(s=>{
        for(const a of ['data-orbit-active','data-orbit-side','data-orbit-offset'])s.removeAttribute(a);
        for(const key of [
          'position','left','top','right','bottom','width','max-width','height','max-height',
          'margin','transform','opacity','visibility','z-index','pointer-events'
        ])s.style.removeProperty(key);
      });
    };

    const paint=()=>{
      cancelAnimationFrame(raf);
      raf=requestAnimationFrame(()=>{
        if(reduce.matches||!desktop.matches){cleanup();return;}

        const all=slides();
        const n=all.length;
        if(!n){cleanup();return;}

        const a=Math.min(activeIndex(),n-1);
        const stageW=Math.max(360,stage.getBoundingClientRect().width||stage.clientWidth||0);
        const vh=Math.max(560,window.innerHeight||720);
        const stageCap=vh<=720?360:Math.min(510,Math.max(390,vh-180));

        const ratioFor=slide=>{
          const img=slide?.querySelector?.('img.product-gallery__image');
          const attrW=Number(img?.getAttribute?.('width')||0);
          const attrH=Number(img?.getAttribute?.('height')||0);
          const w=Number(img?.naturalWidth||attrW||0);
          const h=Number(img?.naturalHeight||attrH||0);
          if(w>0&&h>0)return Math.min(2.2,Math.max(.58,w/h));
          return 1;
        };

        const fitToBox=(ratio,maxW,maxH)=>{
          let w=maxW;
          let h=w/ratio;
          if(h>maxH){
            h=maxH;
            w=h*ratio;
          }
          return {
            w:Math.max(205,Math.round(w)),
            h:Math.max(205,Math.round(h))
          };
        };

        const maxCardW=Math.min(stageW<640?330:470,Math.max(280,stageW*.68));
        const maxCardH=Math.max(280,stageCap-28);
        const activeSize=fitToBox(ratioFor(all[a]),maxCardW,maxCardH);
        const activeW=activeSize.w;
        const activeH=activeSize.h;

        /* Tight stage: follow the media card instead of leaving a tall dark plate. */
        const stagePadding=24;
        const stageH=Math.min(stageCap,Math.max(300,activeH+stagePadding));
        const sideX=Math.min(stageW*.31,Math.max(activeW*.60,150));

        root.style.setProperty('--mz-orbit-active-h',activeH+'px');
        root.style.setProperty('--mz-orbit-active-w',activeW+'px');

        root.dataset.galleryOrbit='true';
        root.dataset.mzOrbitReady='true';
        root.style.setProperty('--mz-orbit-stage-h',stageH+'px');

        for(const el of [viewport,stage,rail].filter(Boolean)){
          el.style.setProperty('height',stageH+'px','important');
          el.style.setProperty('min-height',stageH+'px','important');
          el.style.setProperty('max-height',stageH+'px','important');
        }

        all.forEach((s,i)=>{
          const d=circularDelta(i,a,n);
          const ad=Math.abs(d);
          const sign=Math.sign(d)||0;
          const active=ad===0;
          const side=ad===1;

          let x=0,y=0,z=55,ry=0,scale=1,opacity=1,zIndex=40,visible=true;
          if(side){
            x=sign*sideX;
            y=0;
            z=-95;
            ry=-sign*10;
            scale=.78;
            opacity=.68;
            zIndex=20;
          }else if(!active){
            visible=false;
            opacity=0;
            zIndex=1;
          }

          s.toggleAttribute('data-orbit-active',active);
          s.toggleAttribute('data-orbit-side',side);
          s.dataset.orbitOffset=String(d);
          s.setAttribute('aria-hidden',active?'false':'true');

          const set=(prop,val)=>s.style.setProperty(prop,val,'important');
          set('position','absolute');
          set('left','50%');
          set('top','50%');
          set('right','auto');
          set('bottom','auto');
          set('width',activeW+'px');
          set('max-width',activeW+'px');

          const mediaRatio=ratioFor(s);
          const ownHeight=Math.max(205,Math.round(activeW/mediaRatio));
          if(s.dataset.mediaType==='image'){
            set('height','auto');
            set('max-height','none');
            set('min-height','0');
          }else{
            set('height',Math.min(ownHeight,maxCardH)+'px');
            set('max-height',Math.min(ownHeight,maxCardH)+'px');
            set('min-height','0');
          }
          set('margin','0');
          set('opacity',String(opacity));
          set('visibility',visible?'visible':'hidden');
          set('z-index',String(zIndex));
          set('pointer-events',active?'auto':'none');
          set(
            'transform',
            'translate(-50%,-50%) translate3d('+x+'px,'+y+'px,'+z+'px) rotateY('+ry+'deg) scale('+scale+')'
          );
        });

        unlockArrows(n);

        requestAnimationFrame(()=>{
          const activeSlide=all[a];
          const activeFrame=activeSlide?.querySelector?.('.product-gallery__media-frame');
          const renderedH=Math.round(activeFrame?.getBoundingClientRect?.().height||0);
          if(renderedH>0){
            const tightH=Math.min(stageCap,Math.max(280,renderedH+24));
            root.style.setProperty('--mz-orbit-active-h',renderedH+'px');
            root.style.setProperty('--mz-orbit-stage-h',tightH+'px');
            for(const el of [viewport,stage,rail].filter(Boolean)){
              el.style.setProperty('height',tightH+'px','important');
              el.style.setProperty('min-height',tightH+'px','important');
              el.style.setProperty('max-height',tightH+'px','important');
            }
          }
        });
      });
    };

    const onArrowClick=e=>{
      if(reduce.matches||!desktop.matches)return;
      const button=e.target?.closest?.('[data-gallery-previous],[data-gallery-next]');
      if(!button||!root.contains(button))return;
      e.preventDefault();
      e.stopImmediatePropagation();
      navigate(button.hasAttribute('data-gallery-next')?1:-1);
    };

    root.addEventListener('click',onArrowClick,true);

    stage.addEventListener('pointerdown',e=>{
      if(e.target?.closest?.(interactive))return;
      if(e.pointerType==='mouse'&&e.button!==0)return;
      startX=lastX=e.clientX;
      lastT=performance.now();
      velocity=0;
    },{passive:true});

    stage.addEventListener('pointermove',e=>{
      if(startX==null)return;
      const now=performance.now();
      const dt=Math.max(1,now-lastT);
      velocity=(e.clientX-lastX)/dt;
      lastX=e.clientX;
      lastT=now;
    },{passive:true});

    stage.addEventListener('pointerup',e=>{
      if(startX==null)return;
      const dx=e.clientX-startX;
      startX=null;
      if(Math.abs(dx)>34||Math.abs(velocity)>.38){
        navigate(dx<0||velocity<-.38?1:-1);
      }
    },{passive:true});

    stage.addEventListener('keydown',e=>{
      if(reduce.matches||!desktop.matches)return;
      if(e.key==='ArrowRight'){e.preventDefault();navigate(1);}
      if(e.key==='ArrowLeft'){e.preventDefault();navigate(-1);}
    },true);

    new MutationObserver(paint).observe(root,{
      attributes:true,
      attributeFilter:['data-gallery-current'],
      childList:true,
      subtree:false
    });

    reduce.addEventListener?.('change',paint);
    desktop.addEventListener?.('change',paint);
    window.addEventListener('resize',paint,{passive:true});
    root.addEventListener('load',e=>{
      if(e.target?.matches?.('img.product-gallery__image'))paint();
    },true);
    paint();
  };

  const scan=(scope=document)=>{
    const roots=scope.matches?.('[data-gallery-root]')
      ?[scope]
      :[...(scope.querySelectorAll?.('[data-gallery-root]')||[])];
    roots.forEach(root=>{if(root.closest('body.template-product'))init(root);});
  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(),{once:true});
  else scan();

  document.addEventListener('shopify:section:load',e=>scan(e.target));
})();